module.exports = __webpack_public_path__ + "static/media/loading-ripple.3228ade8.svg";